import {all} from 'redux-saga/effects';
import auth from './auth.saga';
import purchaseOrder from './purchaseOrder.saga';
import bookingOrder from './booking.saga';

export default function* saga() {
  yield all([auth(), purchaseOrder(), bookingOrder()]);
}
